<template>
    <v-dialog v-model="dialog" max-width="1000" style="background-color: red; max-height: 100%" v-resize="onResize">
        <v-card v-if="isReady" class="standard-row font-theme"
            style="border: 1px solid #000000; border-radius: 20px; padding: 5px 1px 14px 20px;">
            <v-card-title v-if="windowSize.x > 850" class="d-flex justify-space-between align-center"
                style="padding: 0px;">
                <v-row no-gutters class="standard-row" style="font-size: 12px; padding: 14px 14px 14px 0px;">
                <v-btn rounded color="#ffffff" class="ml-auto black--text text-center download-report-vendor-btn"
                    @click="downloadFile">
                    <img src="../assets/excel.png" alt="Excel Icon" width="30" class="mr-2" />
                    ตัวอย่างไฟล์ Import Excel
                </v-btn>
                  <v-btn rounded color="green" class="white--text text-center download-report-vendor-btn ml-2"
                          @click="addFileExcel">
                        <v-icon class="mr-1">mdi-plus</v-icon> Import Excel
                    </v-btn>
                </v-row>
            </v-card-title>
            <v-card-title v-else class="d-flex justify-end align-center" style="padding: 14px 14px 14px 0px;">
                <v-btn rounded color="green" class="white--text text-center download-report-vendor-btn"
                    @click="addFileExcel">
                    <v-icon class="mr-1">mdi-plus</v-icon>
                         Import Excel
                    </v-btn>
            </v-card-title>
            <div class="scroll-theme add-vendor-detail-scroll">
                <v-form lazy-validation ref="headerForm">
                    <template>
                        <p style="font-size: 32px; font-weight: 700;" class="mb-0">Detail</p>
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(item, index) in detailVendor.Detail" :key="`title_${index}`" cols="12" sm="6"
                                md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" :lg="!(index + 1) % 2 ? '6' : '5'"
                                        style="font-weight: 700;" class="pr-sm-3">
                                        {{ index }}
                                    </v-col>
                                    <v-col
                                            v-if="item === 'type_of_vendor'"
                                            cols="12"
                                            sm="12"
                                            md="7"
                                            lg="7"
                                            class="pr-sm-3"
                                            >
                                            <v-autocomplete
                                                v-model="dataInputs.type_of_vendor"
                                                :items="typeOfVendorList"
                                                item-text="type"
                                                item-value="type"
                                                outlined
                                                dense
                                                hide-details
                                                class="dropdown-select"
                                                append-icon="mdi-chevron-down"
                                                color="black"
                                                :disabled="selectedBiz.tax_id !== '0107544000094'"
                                                :rules="selectedBiz.tax_id === '0107544000094' ? textRules : []"
                                            >
                                                <template v-slot:item="{ item }">
                                                <v-list-item-content>
                                                    <v-list-item-title class="font-theme">
                                                    {{ item.type }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                                </template>
                                            </v-autocomplete>
                                    </v-col>
                                    <v-col v-else cols="12" sm="12" md="7" :lg="!(index + 1) % 2 ? '6' : '7'" class="pr-sm-3">
                                        <v-text-field hide-details outlined height="25" v-model="dataInputs[item]"
                                            type="text" color="black"
                                            class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc"
                                            :rules="textRules" required></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <!-- <v-col v-if="selectedBiz.tax_id === '0107544000094' && item === 'type_of_vendor'" md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" lg="5"
                                        style="font-weight: 700;" class="pr-sm-3">
                                        Type Of Vendor
                                    </v-col>
                                    <v-col cols="12" sm="12" md="7"  lg="7" class="pr-sm-3">
                                         <v-autocomplete
                                        v-model="dataInputs.type_of_vendor"
                                        :items="typeOfVendorList"
                                        item-text="type"
                                        item-value="type"
                                        outlined
                                        dense
                                        hide-details
                                        class="dropdown-select"
                                        append-icon="mdi-chevron-down"
                                        color="black"
                                        :rules="textRules"
                                        required 
                                        >
                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                            <v-list-item-title
                                                class="font-theme"
                                            >
                                                {{ item.type }}
                                            </v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-col> -->
                            <v-col md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" lg="5"
                                        style="font-weight: 700;" class="pr-sm-3">
                                        Tax Id
                                    </v-col>
                                    <v-col cols="12" sm="12" md="7"  lg="7" class="pr-sm-3">
                                        <v-text-field hide-details outlined height="25" v-model="selectedBiz.tax_id"
                                            type="text" color="black" readonly
                                            class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc"
                                            :rules="textRules" required></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                    <template>
                        <p style="font-size: 32px; font-weight: 700;" class="mb-0">Address</p>
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(item, index) in detailVendor.Address" :key="`title_${index}`" cols="12"
                                sm="6" md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" :lg="!(index + 1) % 2 ? '6' : '5'"
                                        style="font-weight: 700;" class="pr-sm-3">
                                        {{ index }}
                                    </v-col>
                                    <v-col cols="12" sm="12" md="7" :lg="!(index + 1) % 2 ? '6' : '7'" class="pr-sm-3">
                                        <v-text-field hide-details outlined height="25" v-model="dataInputs[item]"
                                            type="text" color="black"
                                            class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc"
                                            :rules="textRules" required></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                    <template>
                        <p style="font-size: 32px; font-weight: 700;" class="mb-0">Payment</p>
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(item, index) in detailVendor.Payment" :key="`title_${index}`" cols="12"
                                sm="6" md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" :lg="!(index + 1) % 2 ? '6' : '5'"
                                        style="font-weight: 700;" class="pr-sm-3">
                                        {{ index }}
                                    </v-col>
                                    <v-col cols="12" sm="12" md="7" :lg="!(index + 1) % 2 ? '6' : '7'" class="pr-sm-3">
                                        <v-text-field hide-details outlined height="25" v-model="dataInputs[item]"
                                            type="text" color="black"
                                            class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc"
                                            :rules="textRules" required></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                    <template>
                        <p style="font-size: 32px; font-weight: 700;" class="mb-0">Contact</p>
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(item, index) in detailVendor.Contact" :key="`title_${index}`" cols="12"
                                sm="6" md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" :lg="!(index + 1) % 2 ? '6' : '5'"
                                        style="font-weight: 700;" class="pr-sm-3">
                                        {{ index }}
                                    </v-col>
                                    <v-col cols="12" sm="12" md="7" :lg="!(index + 1) % 2 ? '6' : '7'" class="pr-sm-3">
                                        <v-text-field hide-details outlined height="25" v-model="dataInputs[item]"
                                            type="text" color="black" class="py-0 font-theme border-radius-box"
                                            :rules="textRules" required></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                    <v-row class="standard-row text-center d-flex justify-end create-document-row">
                        <div class="mr-3">
                            <v-btn rounded @click="closeDialog()" color="red"
                                class="elevation-0 font-theme confirm-btn white--text mr-2"
                                style="width: 100px; height: 35px;">
                                ยกเลิก
                            </v-btn>
                            <v-btn rounded @click="submitForm()" color="#0B68D6"
                                class="elevation-0 font-theme confirm-btn white--text ml-1"
                                style="width: 100px; height: 35px;">
                                ยืนยัน
                            </v-btn>
                        </div>
                    </v-row>
                </v-form>
            </div>
        </v-card>
        <addExcelModal />
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
import addExcelModal from '../components/addExcelModal.vue'
export default {
    components: {
        addExcelModal
    },
    data: () => ({
        textRules: [v => !!v],
         textRulesMultiple: [
            v => Array.isArray(v) && v.length > 0 || 'กรุณาเลือก Cost Center'
        ],
        dialog: false,
        isReady: false,
        detailVendor: {},
        dataInputs: {},
        windowSize: { x: 0 },
        ListDetailVendor: [],
        fileName: null,
        file: null,
        type_of_vendor: '',
        typeOfVendorList: [
                {
                    "type": "Other"
                },
                {
                    "type": "ย่อย"
                },
                {
                    "type": "ร่วม-ร่วมค้า-ผู้ถือหุ้น"
                }
        ],                
    }),
    watch: {
        "dialog"(newVal) {
            if (!newVal) {
                this.dataInputs = []
                this.fileName = null;
                this.file = null;
            }
        }
    },
    computed: {
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        },
    },
    mounted() {
        EventBus.$on('openAddVendorDetail', this.openDialog)
        EventBus.$on('offDialog', this.closeDialog);
    },
    beforeDestroy() {
        EventBus.$off('openAddVendorDetail')
        EventBus.$off('offDialog')
    },
    methods: {
        openDialog() {
            this.isReady = false
            this.onResize()
            this.detailVendor = {
                Detail: {
                    'Vendor Code': 'vendor_code',
                    'Title Name': 'title_name',
                    'Vendor Name (TH)': 'vendor_name_th',
                    'Vendor Name (ENG)': 'vendor_name_eng',
                    'Vendor Group Code': 'vendor_group_code',
                    'Vendor Group Name': 'vendor_group_name',
                    'Currency': 'currency',
                    'คำนำหน้าชื่อ': 'titlename_2',
                    'Branch Code': 'branch_code',
                    'Description': 'description',
                    'Tax Id Vendor': 'tax_id_vendor',
                    'Address Code': 'address_code',
                    'Pur Org.': 'pur_org',
                    'PurOrg - Description': 'pur_org_description',
                    'Pur Group': 'pur_group',
                    'PurGroup - Description': 'pur_group_description',
                    'Head Office': 'head_office',
                    'Type Of Vendor': 'type_of_vendor',
                    // 'Tax Id': 'tax_id',
                },
                Address: {
                    'เลขที่': 'house_no',
                    'อาคาร': 'building',
                    'หมู่ที่': 'village_no',
                    'ซอย': 'lane',
                    'ถนน': 'road',
                    'แขวง': 'sub_district',
                    'เขต/อำเภอ': 'district',
                    'จังหวัด': 'province',
                    'รหัสไปรษณีย์': 'postal_code',
                },
                Payment: {
                    'เงื่อนไขการชำระเงิน': 'payment_term',
                    'Statement Term': 'statement_term',
                    'Collection Term': 'collection_term',
                    'เงื่อนไขการติดตามหนี้': 'debt_collection_conditions',
                    'บัญชีเจ้าหนี้': 'creditor_account',
                    'ชื่อบัญชีเจ้าหนี้': 'creditor_name',
                    'การหักบัญชี': 'clearing',
                    'ชื่อการหักบัญชี': 'clearing_name',
                    'รหัสภาษีมูลค่าเพิ่ม': 'vat_code',
                    'ชื่อรหัสภาษีมูลค่าเพิ่ม': 'vat_code_name',
                },
                Contact: {
                    'ชื่อผู้ติดต่อ': 'contact_name',
                    'ผู้ติดต่อ - ตำแหน่ง': 'contact_position',
                    'ผู้ติดต่อ - หมายเหตุ': 'contact_note',
                    'ผู้ติดต่อ - Mobile': 'contact_mobile',
                    'ผู้ติดต่อ - หมายเลขโทรศัพท์ติดต่อ 1': 'phone_2',
                    'ผู้ติดต่อ - หมายเลขโทรศัพท์ติดต่อ 2': 'contact_tel2',
                    'ผู้ติดต่อ - Fax': 'contact_fax',
                    'ผู้ติดต่อ - E-Mail': 'contact_email',
                    'Tel 1': 'phone_1',
                    'Tel 2': 'tel2',
                    'Mobile': 'mobile',
                    'Fax': 'fax',
                    'E-Mail': 'email',
                    'Website': 'website',
                }
            };

            this.$nextTick(() => {
                this.dialog = true
                this.isReady = true
                document.getElementsByClassName('v-dialog--active')[0] ? document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0 : null
            })
        },
        addFileExcel() {
            EventBus.$emit('uploadFileExcel')
        },
        closeDialog() {
            this.dialog = false;
        },
        async submitForm() {
            if (this.$refs.headerForm.validate()) {
                this.ListDetailVendor = {
                    vendor_code: this.dataInputs['vendor_code'],
                    titlename_1: this.dataInputs['title_name'] || '-',
                    companyname_1: this.dataInputs['vendor_name_th'] || '-',
                    vendor_name_eng: this.dataInputs['vendor_name_eng'] || '-',
                    vendorgroupcode: this.dataInputs['vendor_group_code'] || '-',
                    dropdownbox22416: this.dataInputs['vendor_group_name'] || '-',
                    currency: this.dataInputs['currency'] || '-',
                    titlename_2: this.dataInputs['titlename_2'] || '-',
                    Branch_Code: this.dataInputs['branch_code'] || '-',
                    description: this.dataInputs['description'] || '-',
                    tax_id_vendor: this.dataInputs['tax_id_vendor'] || '-',
                    AddressCode: this.dataInputs['address_code'] || '-',
                    JV_company: this.selectedBiz.business_detail.name_on_document_th|| '-',
                    jv_no: this.dataInputs['pur_org'] || '-',
                    jv_name: this.dataInputs['pur_org_description'] || '-',
                    pur_group: this.dataInputs['pur_group'] || '-',
                    pur_description : this.dataInputs['pur_group_description'] || '-',
                    head_office: this.dataInputs['head_office'] || '-',
                    Tax_ID: this.selectedBiz.tax_id,
                    ...(this.selectedBiz.tax_id === '0107544000094' && {
                        type_of_vendor: this.dataInputs['type_of_vendor'] || '-'
                    }),
                    no_1: this.dataInputs['house_no'] || '-',
                    building_1: this.dataInputs['building'] || '-',
                    moo_1: this.dataInputs['village_no'] || '-',
                    soi_1: this.dataInputs['lane'] || '-',
                    road_1: this.dataInputs['road'] || '-',
                    district1: this.dataInputs['sub_district'] || '-',
                    area1: this.dataInputs['district'] || '-',
                    city1: this.dataInputs['province'] || '-',
                    postcode1: this.dataInputs['postal_code'] || '-',

                    creditterm_1: this.dataInputs['payment_term'] || '-',
                    statement_term: this.dataInputs['statement_term'] || '-',
                    collection_term: this.dataInputs['collection_term'] || '-',
                    debt_collection_conditions: this.dataInputs['debt_collection_conditions'] || '-',
                    textareabox8881 : this.dataInputs['creditor_account'] || '-',
                    creditor_name: this.dataInputs['creditor_name'] || '-',
                    clearing: this.dataInputs['clearing'] || '-',
                    clearing_name: this.dataInputs['clearing_name'] || '-',
                    vat_code: this.dataInputs['vat_code'] || '-',
                    vat_code_name: this.dataInputs['vat_code_name'] || '-',

                    contractname_1: this.dataInputs['contact_name'] || '-',
                    contact_position: this.dataInputs['contact_position'] || '-',
                    contact_note: this.dataInputs['contact_note'] || '-',
                    contact_mobile: this.dataInputs['contact_mobile'] || '-',
                    phone_2: this.dataInputs['phone_2'] || '-',
                    contact_tel2: this.dataInputs['contact_tel2'] || '-',
                    contact_fax: this.dataInputs['contact_fax'] || '-',
                    contact_email: this.dataInputs['contact_email'] || '-',
                    phone_1: this.dataInputs['phone_1'] || '-',
                    tel2: this.dataInputs['tel2'] || '-',
                    mobile: this.dataInputs['mobile'] || '-',
                    fax_1: this.dataInputs['fax'] || '-',
                    email_1: this.dataInputs['email'] || '-',
                    web_1: this.dataInputs['website'] || '-',
                };
                try {
                    const { data } = await this.axios.post(
                        `${this.$api_url}/vendor_erp/api/v1/create_vendorerp`,
                        this.ListDetailVendor
                    )
                    if (data.status) {
                        this.alert('เพิ่มข้อมูลสำเร็จ', 'Success', 'success')
                        this.dialog = false;
                        setTimeout(() => {
                            EventBus.$emit("reloadGlAccountPage");
                        }, 1000);
                    } else {
                        this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    console.log(error);
                }

            } else {
                this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
        },
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        downloadFile() {
            if(this.selectedBiz.tax_id === '0107544000094'){
                const link = document.createElement('a');
                link.href = '/file/vendor_inet.xlsx'; // Path relative to the public directory
                link.download = 'vendor_inet.xlsx'; // Adjust the download file name as necessary
                link.click();
                this.alert('ดาวน์โหลดไฟล์สำเร็จ', 'Success', 'success');
            }else{
                const link = document.createElement('a');
                link.href = '/file/vendor_other_biz.xlsx'; // Path relative to the public directory
                link.download = 'vendor_other_biz.xlsx'; // Adjust the download file name as necessary
                link.click();
                this.alert('ดาวน์โหลดไฟล์สำเร็จ', 'Success', 'success');
            }  
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    }
}
</script>

<style>
.add-vendor-detail-scroll {
    padding-right: 10px;
    color: black;
    overflow-y: auto;
    border-radius: 0px !important;
    max-height: calc(100vh - 158px);
}

@media only screen and (max-width: 600px) {
    .add-vendor-detail-scroll {
        max-height: calc(100vh - 238px) !important;
    }
}
</style>